import type { PostParent, PostChild } from '$lib/api/restApi';
import { generateHTML } from '@tiptap/core';
import type { Editor } from 'svelte-tiptap';
import type { JSONContent } from '@tiptap/core';
import { textExtensions } from '$textEditor/textExtensions';
import { createEmptyPost } from '$textEditor/PostComposer/composerStore';
import { getPostAttributesFromEditorContent } from '$textEditor/utils/getPostAttributesFromEditorContent';

const convertToHtml = (element: JSONContent): string => {
	return generateHTML({ type: 'doc', content: [element] }, textExtensions());
};

export const editorStoreToPost = (editor: Editor, postArg?: PostParent): PostParent => {
	const post = postArg || createEmptyPost();

	const editorContent = editor.getJSON().content;

	if (!editorContent) {
		return post;
	}

	const { title, description, context } = getPostAttributesFromEditorContent(editorContent);

	post.title = title;
	post.description = description;
	post.context = context;

	// Reset post children
	post.children = [];

	editorContent.forEach((item) => {
		if (!item.type?.includes('hubs')) {
			const html = convertToHtml(item);
			if (html) {
				post.children.push({
					type: 'text',
					body: html,
					children: [],
				});
			}
		} else if (item.type === 'hubsGalleryComponent') {
			const gallery: PostChild = {
				type: 'gallery',
				children: [],
				body: '',
			};
			if (item.attrs?.images) {
				(item.attrs?.images as Array<PostChild>).forEach((image, index) => {
					if (index === 0) {
						// @ts-ignore
						image.title = item.attrs?.title as string;
						image.body = item.attrs?.description as string;
					}
					// @ts-ignore
					gallery.children?.push(image);
				});
				post.children.push(gallery);
			}
		} else if (item.type?.startsWith('hubs')) {
			if (item.attrs?.post) {
				const hubs = item.attrs?.post as PostChild | undefined;
				if (hubs) {
					post.children.push(hubs);
				}
			}
		}
	});

	return post;
};
